// extracted by mini-css-extract-plugin
module.exports = {"Badge":"badge_Badge__f82r0"};